/* User Action Types */

export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";

/* Channel Action Types */

export const SET_CURRENT_CHANNEL = "SET_CURRENT-CHANNEL";
export const SET_PRIVATE_CHANNEL = "SET_PRIVATE_CHANNEL";

/* Posts Avtion Types */
export const SET_USER_POSTS = "SET_USER_POSTS";

/* Color Action Types */
export const SET_COLORS = "SET_COLORS";


// WEBPACK FOOTER //
// ./src/redux/actions/types.actions.js